import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';

import { Context } from '../context/DataContext';

const SelectInstallmentPage = () => {
  const navigate = useNavigate();
  const { state, updateCreditInstallment } = React.useContext(Context);
  const {
    installmentsList,
    customerInfo: { orderId },
  } = state;
  const [errorMsg, setErrorMsg] = React.useState('');
  const [result, setResult] = React.useState('');

  return (
    <Box>
      <Typography variant='h4' sx={{ my: 2 }}>
        分期付款
      </Typography>
      {installmentsList && installmentsList.length > 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: 320,
              boxShadow: '0 0 0.4rem rgb(0 0 0 / 25%)',
              boxSizing: 'border-box',
              borderRadius: 2,
              px: 3,
              py: 4,
              mb: 3,
            }}
          >
            <FormControl fullWidth>
              <FormLabel id={`installment-selection`} sx={{ fontSize: 24 }}>
                請選擇分期
              </FormLabel>
              <RadioGroup
                aria-labelledby={`installment-selection`}
                name={`installment-selection`}
                onChange={(e) => setResult(e.target.value)}
                value={result}
              >
                {installmentsList.map(({ OptionsName, OptionsKey }, index) => {
                  const isLastIndex = index + 1 === installmentsList.length;

                  return isLastIndex ? (
                    <FormControlLabel
                      key={`${OptionsName}_${index}`}
                      value={OptionsKey}
                      control={<Radio />}
                      label={OptionsName}
                    />
                  ) : (
                    <React.Fragment key={`${OptionsName}_${index}`}>
                      <FormControlLabel
                        value={OptionsKey}
                        control={<Radio />}
                        label={OptionsName}
                      />
                      <Divider />
                    </React.Fragment>
                  );
                })}
              </RadioGroup>
            </FormControl>
          </Box>
          {errorMsg ? (
            <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
              {errorMsg}
            </Typography>
          ) : null}
          <Button
            variant='contained'
            sx={{ width: 168 }}
            onClick={() => {
              if (!result) {
                setErrorMsg('請選擇分期期數。');
                return;
              }

              updateCreditInstallment(
                {
                  orderId,
                  creditInstallment: result,
                },
                ({ responseCode, responseMsg }) => {
                  if (responseCode === '000') {
                    navigate('/upload-photos');
                  } else {
                    setErrorMsg(responseMsg);
                  }
                }
              );
            }}
          >
            下一步
          </Button>
        </Box>
      ) : (
        <Box>
          <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
            查無分期資料
          </Typography>
          <Button
            sx={{ width: 168 }}
            onClick={() => {
              navigate('/tap-pay');
            }}
          >
            回上一頁
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SelectInstallmentPage;
